import React, { useState } from 'react';
import { LeftSidebar } from './LeftSidebar';
import { RightSidebar } from './RightSidebar';
import { MobileBottomNav } from './MobileBottomNav';
import { MobileTopBar } from './MobileTopBar';
import { SignedOutBanner } from './SignedOutBanner';
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import { ComposeBox } from '@/components/tweet/ComposeBox';

interface AppLayoutProps {
  children: React.ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
  const [isComposeOpen, setIsComposeOpen] = useState(false);

  const handleOpenCompose = () => setIsComposeOpen(true);
  const handleCloseCompose = () => setIsComposeOpen(false);

  return (
    <div className="min-h-screen bg-background text-foreground flex justify-center selection:bg-sky-500/35 relative pb-16 md:pb-0">
      <div className="flex w-full max-w-[1250px] relative">
        {/* Left Sidebar - Desktop */}
        <LeftSidebar onOpenCompose={handleOpenCompose} />

        {/* Center Main Area */}
        <main className="flex-1 max-w-[600px] border-r border-border min-h-screen pb-16 md:pb-0 relative w-full flex flex-col">
          {/* Mobile Top Header */}
          <MobileTopBar onOpenCompose={handleOpenCompose} />
          <div className="flex-1 flex flex-col">
            {children}
          </div>
        </main>

        {/* Right Sidebar - Desktop */}
        <RightSidebar />

        {/* Mobile Fixed Bottom Navigation */}
        <MobileBottomNav onOpenCompose={handleOpenCompose} />

        {/* Floating Signed Out Footer Banner */}
        <SignedOutBanner />

        {/* Modal Compose Dialogue */}
        <Dialog open={isComposeOpen} onOpenChange={setIsComposeOpen}>
          <DialogContent className="sm:max-w-[600px] p-0 top-[10%] translate-y-0 rounded-2xl overflow-hidden border border-border">
            <DialogTitle className="sr-only">Compose new Post</DialogTitle>
            <div className="p-4 border-b border-border flex items-center justify-between">
              <span className="font-extrabold text-[15px]">Create new post</span>
            </div>
            <div className="p-4 pt-2">
              <ComposeBox onPostSuccess={handleCloseCompose} autoFocus placeholder="What's happening?!" />
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </div>
  );
}
